import { render, staticRenderFns } from "./batchInspection.vue?vue&type=template&id=7088d2b6&scoped=true"
import script from "./batchInspection.vue?vue&type=script&lang=js"
export * from "./batchInspection.vue?vue&type=script&lang=js"
import style0 from "./batchInspection.vue?vue&type=style&index=0&id=7088d2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088d2b6",
  null
  
)

export default component.exports